<section class="profile-box__avatar-container flex flex-col items-center mb-6">
  <figure class="py-8">
    <img src="assets/img/avatar-placeholder.svg" alt="Zaślepka avatara" />
  </figure>
  <p class="text-lg">Użytkownik</p>
  <p class="text-sky-grey font-bold">{{ userName }}</p>
</section>

<section *ngIf="provider" class="profile-box__info-container">
  <h2 class="font-bold text-sky-blue border-sky-blue border-b-2 text-center mb-4">Konto</h2>
  <p>
    Dostawca: <span class="font-bold">{{ provider.provider.providerName }}</span>
  </p>
  <p>{{ provider.provider.providerDescription }}</p>
  <p>{{ provider.provider.street }}</p>
  <p>{{ provider.provider.postCode }} {{ provider.provider.city }}</p>
</section>
